(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './androidx-lifecycle-lifecycle-common.js', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./androidx-lifecycle-lifecycle-common.js'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof globalThis['androidx-lifecycle-lifecycle-common'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-runtime'. Its dependency 'androidx-lifecycle-lifecycle-common' was not found. Please, check whether 'androidx-lifecycle-lifecycle-common' is loaded prior to 'androidx-lifecycle-lifecycle-runtime'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-runtime'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-lifecycle-lifecycle-runtime'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-runtime'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'androidx-lifecycle-lifecycle-runtime'.");
    }
    globalThis['androidx-lifecycle-lifecycle-runtime'] = factory(typeof globalThis['androidx-lifecycle-lifecycle-runtime'] === 'undefined' ? {} : globalThis['androidx-lifecycle-lifecycle-runtime'], globalThis['androidx-lifecycle-lifecycle-common'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core']);
  }
}(function (_, kotlin_androidx_lifecycle_lifecycle_common, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var State_CREATED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.k;
  var toString = kotlin_kotlin.$_$.hp;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var State_INITIALIZED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.m;
  var State_DESTROYED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.l;
  var protoOf = kotlin_kotlin.$_$.eh;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var first = kotlin_kotlin.$_$.p9;
  var last = kotlin_kotlin.$_$.oa;
  var toList = kotlin_kotlin.$_$.kc;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var KtMap = kotlin_kotlin.$_$.g7;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Companion_instance = kotlin_androidx_lifecycle_lifecycle_common.$_$.c;
  var reversed = kotlin_kotlin.$_$.pb;
  var lastOrNull = kotlin_kotlin.$_$.ia;
  var Lifecycling_instance = kotlin_androidx_lifecycle_lifecycle_common.$_$.d;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var Lifecycle = kotlin_androidx_lifecycle_lifecycle_common.$_$.b;
  var MutableStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s1;
  var VOID = kotlin_kotlin.$_$.d;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ObserverWithState, 'ObserverWithState');
  initMetadataForCompanion(Companion);
  initMetadataForClass(LifecycleRegistry, 'LifecycleRegistry', VOID, Lifecycle);
  initMetadataForClass(WeakReference, 'WeakReference');
  //endregion
  function checkLifecycleStateTransition(owner, current, next) {
    if (current.equals(State_INITIALIZED_getInstance()) && next.equals(State_DESTROYED_getInstance())) {
      // Inline function 'kotlin.error' call
      var message = "State must be at least '" + State_CREATED_getInstance().toString() + "' to be moved to '" + next.toString() + "' in component " + toString(owner);
      throw IllegalStateException_init_$Create$(toString_0(message));
    }
    if (current.equals(State_DESTROYED_getInstance()) && !current.equals(next)) {
      // Inline function 'kotlin.error' call
      var message_0 = "State is '" + State_DESTROYED_getInstance().toString() + "' and cannot be moved to `" + next.toString() + '` in component ' + toString(owner);
      throw IllegalStateException_init_$Create$(toString_0(message_0));
    }
  }
  function LifecycleRegistry_init_$Init$(provider, $this) {
    LifecycleRegistry.call($this, provider, true);
    return $this;
  }
  function LifecycleRegistry_init_$Create$(provider) {
    return LifecycleRegistry_init_$Init$(provider, objectCreate(protoOf(LifecycleRegistry)));
  }
  function moveToState($this, next) {
    if ($this.k7n_1.equals(next)) {
      return Unit_instance;
    }
    checkLifecycleStateTransition($this.l7n_1.f1i(), $this.k7n_1, next);
    $this.k7n_1 = next;
    if ($this.n7n_1 || !($this.m7n_1 === 0)) {
      $this.o7n_1 = true;
      return Unit_instance;
    }
    $this.n7n_1 = true;
    sync($this);
    $this.n7n_1 = false;
    if ($this.k7n_1.equals(State_DESTROYED_getInstance())) {
      var tmp = $this;
      // Inline function 'kotlin.collections.linkedMapOf' call
      tmp.j7n_1 = LinkedHashMap_init_$Create$();
    }
  }
  function _get_isSynced__dwdj3t($this) {
    if ($this.j7n_1.r()) {
      return true;
    }
    var eldestObserverState = first($this.j7n_1.y2()).s7n_1;
    var newestObserverState = last($this.j7n_1.y2()).s7n_1;
    return eldestObserverState.equals(newestObserverState) && $this.k7n_1.equals(newestObserverState);
  }
  function calculateTargetState($this, observer) {
    // Inline function 'kotlin.let' call
    var it = toList($this.j7n_1.x2());
    var index = it.q1(observer);
    var tmp;
    if (index > 0) {
      var tmp0_safe_receiver = $this.j7n_1.w2(it.l1(index - 1 | 0));
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s7n_1;
    } else {
      tmp = null;
    }
    var siblingState = tmp;
    var tmp_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!$this.p7n_1.r()) {
      tmp_0 = $this.p7n_1.l1($this.p7n_1.n1() - 1 | 0);
    } else {
      tmp_0 = null;
    }
    var parentState = tmp_0;
    return Companion_instance_0.u7n(Companion_instance_0.u7n($this.k7n_1, siblingState), parentState);
  }
  function popParentState($this) {
    $this.p7n_1.h3($this.p7n_1.n1() - 1 | 0);
  }
  function pushParentState($this, state) {
    $this.p7n_1.j1(state);
  }
  function forwardPass($this, lifecycleOwner) {
    // Inline function 'androidx.lifecycle.LifecycleRegistry.forEachObserverWithAdditions' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var visited = LinkedHashSet_init_$Create$();
    $l$loop: while (!$this.o7n_1) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this.j7n_1.x2();
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!visited.m1(element)) {
          destination.j1(element);
        }
      }
      var keys = destination;
      if (keys.r()) {
        break $l$loop;
      }
      var _iterator__ex2g4s_0 = keys.t();
      $l$loop_1: while (_iterator__ex2g4s_0.u()) {
        var key = _iterator__ex2g4s_0.v();
        if ($this.o7n_1) {
          break $l$loop_1;
        }
        var tmp0_elvis_lhs = $this.j7n_1.w2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var value = tmp;
        $l$loop_2: while (true) {
          var tmp_0;
          if (value.s7n_1.i3($this.k7n_1) < 0 && !$this.o7n_1) {
            // Inline function 'kotlin.collections.contains' call
            // Inline function 'kotlin.collections.containsKey' call
            var this_0 = $this.j7n_1;
            tmp_0 = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(key);
          } else {
            tmp_0 = false;
          }
          if (!tmp_0) {
            break $l$loop_2;
          }
          pushParentState($this, value.s7n_1);
          var tmp0_elvis_lhs_0 = Companion_instance.l70(value.s7n_1);
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            throw IllegalStateException_init_$Create$('no event up from ' + value.s7n_1.toString());
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var event = tmp_1;
          value.v7n(lifecycleOwner, event);
          popParentState($this);
        }
        visited.j1(key);
      }
    }
  }
  function backwardPass($this, lifecycleOwner) {
    // Inline function 'androidx.lifecycle.LifecycleRegistry.forEachObserverReversed' call
    var keys = reversed($this.j7n_1.x2());
    var _iterator__ex2g4s = keys.t();
    $l$loop_0: while (_iterator__ex2g4s.u()) {
      var key = _iterator__ex2g4s.v();
      if ($this.o7n_1) {
        break $l$loop_0;
      }
      var tmp0_elvis_lhs = $this.j7n_1.w2(key);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var value = tmp;
      $l$loop_1: while (true) {
        var tmp_0;
        if (value.s7n_1.i3($this.k7n_1) > 0 && !$this.o7n_1) {
          // Inline function 'kotlin.collections.contains' call
          // Inline function 'kotlin.collections.containsKey' call
          var this_0 = $this.j7n_1;
          tmp_0 = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(key);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          break $l$loop_1;
        }
        var tmp0_elvis_lhs_0 = Companion_instance.k70(value.s7n_1);
        var tmp_1;
        if (tmp0_elvis_lhs_0 == null) {
          throw IllegalStateException_init_$Create$('no event down from ' + value.s7n_1.toString());
        } else {
          tmp_1 = tmp0_elvis_lhs_0;
        }
        var event = tmp_1;
        pushParentState($this, event.o70());
        value.v7n(lifecycleOwner, event);
        popParentState($this);
      }
    }
  }
  function sync($this) {
    var tmp0_elvis_lhs = $this.l7n_1.f1i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('LifecycleOwner of this LifecycleRegistry is already garbage collected. It is too late to change lifecycle state.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var lifecycleOwner = tmp;
    while (!_get_isSynced__dwdj3t($this)) {
      $this.o7n_1 = false;
      if ($this.k7n_1.i3(first($this.j7n_1.y2()).s7n_1) < 0) {
        backwardPass($this, lifecycleOwner);
      }
      var newest = lastOrNull($this.j7n_1.y2());
      if (!$this.o7n_1 && !(newest == null) && $this.k7n_1.i3(newest.s7n_1) > 0) {
        forwardPass($this, lifecycleOwner);
      }
    }
    $this.o7n_1 = false;
    $this.q7n_1.s21($this.v70());
  }
  function enforceMainThreadIfNeeded($this, methodName) {
    if ($this.i7n_1) {
      // Inline function 'kotlin.check' call
      if (!isMainThread()) {
        var message = 'Method ' + methodName + ' must be called on the main thread';
        throw IllegalStateException_init_$Create$(toString_0(message));
      }
    }
  }
  function ObserverWithState(observer, initialState) {
    this.t7n_1 = Lifecycling_instance.x70(ensureNotNull(observer));
    this.s7n_1 = initialState;
  }
  protoOf(ObserverWithState).v7n = function (owner, event) {
    var newState = event.o70();
    this.s7n_1 = Companion_instance_0.u7n(this.s7n_1, newState);
    this.t7n_1.j70(ensureNotNull(owner), event);
    this.s7n_1 = newState;
  };
  function Companion() {
  }
  protoOf(Companion).w7n = function (owner) {
    return new LifecycleRegistry(owner, false);
  };
  protoOf(Companion).u7n = function (state1, state2) {
    return !(state2 == null) && state2.i3(state1) < 0 ? state2 : state1;
  };
  var Companion_instance_0;
  function Companion_getInstance() {
    return Companion_instance_0;
  }
  function LifecycleRegistry(provider, enforceMainThread) {
    Lifecycle.call(this);
    this.i7n_1 = enforceMainThread;
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.j7n_1 = LinkedHashMap_init_$Create$();
    this.k7n_1 = State_INITIALIZED_getInstance();
    this.m7n_1 = 0;
    this.n7n_1 = false;
    this.o7n_1 = false;
    this.p7n_1 = ArrayList_init_$Create$();
    this.l7n_1 = new WeakReference(provider);
    this.q7n_1 = MutableStateFlow(State_INITIALIZED_getInstance());
  }
  protoOf(LifecycleRegistry).x7n = function (state) {
    enforceMainThreadIfNeeded(this, 'setCurrentState');
    moveToState(this, state);
  };
  protoOf(LifecycleRegistry).v70 = function () {
    return this.k7n_1;
  };
  protoOf(LifecycleRegistry).y7n = function (event) {
    enforceMainThreadIfNeeded(this, 'handleLifecycleEvent');
    moveToState(this, event.o70());
  };
  protoOf(LifecycleRegistry).t70 = function (observer) {
    enforceMainThreadIfNeeded(this, 'addObserver');
    var initialState = this.k7n_1.equals(State_DESTROYED_getInstance()) ? State_DESTROYED_getInstance() : State_INITIALIZED_getInstance();
    var statefulObserver = new ObserverWithState(observer, initialState);
    var previous = this.j7n_1.z2(observer, statefulObserver);
    if (!(previous == null)) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = this.l7n_1.f1i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var lifecycleOwner = tmp;
    var isReentrance = !(this.m7n_1 === 0) || this.n7n_1;
    var targetState = calculateTargetState(this, observer);
    this.m7n_1 = this.m7n_1 + 1 | 0;
    $l$loop: while (true) {
      var tmp_0;
      if (statefulObserver.s7n_1.i3(targetState) < 0) {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_0 = this.j7n_1;
        tmp_0 = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(observer);
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        break $l$loop;
      }
      pushParentState(this, statefulObserver.s7n_1);
      var tmp1_elvis_lhs = Companion_instance.l70(statefulObserver.s7n_1);
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        throw IllegalStateException_init_$Create$('no event up from ' + statefulObserver.s7n_1.toString());
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var event = tmp_1;
      statefulObserver.v7n(lifecycleOwner, event);
      popParentState(this);
      targetState = calculateTargetState(this, observer);
    }
    if (!isReentrance) {
      sync(this);
    }
    this.m7n_1 = this.m7n_1 - 1 | 0;
  };
  protoOf(LifecycleRegistry).u70 = function (observer) {
    enforceMainThreadIfNeeded(this, 'removeObserver');
    this.j7n_1.a3(observer);
  };
  function isMainThread() {
    return true;
  }
  function WeakReference(reference) {
    this.r7n_1 = reference;
  }
  protoOf(WeakReference).f1i = function () {
    return this.r7n_1;
  };
  //region block: init
  Companion_instance_0 = new Companion();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_instance_0;
  _.$_$.b = LifecycleRegistry_init_$Create$;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-lifecycle-lifecycle-runtime.js.map
